import { makeAutoObservable, runInAction } from 'mobx';
import { enableStaticRendering } from 'mobx-react-lite';
import { Session } from 'next-auth';
import { isSSR } from '../utils/helpers';
import { ActiveTicketStore } from './childStore/activeTicketStore';
import { CurrentUserStore } from './childStore/currentUserStore';
import { GrispiNewsStore } from './childStore/grispiNewsStore';
import { MacroStore } from './childStore/macroStore';
import { PluginStore } from './childStore/pluginStore';
import { SecurityStore } from './childStore/securityStore';
import { TabStore } from './childStore/tabStore';
import { TicketFormUtilStore } from './childStore/ticketFormUtilStore';
import { UtilStore } from './childStore/utilStore';

enableStaticRendering(isSSR());

export type RootStoreHydrationData = {
    session: Session;
    openTabKeys: string;
    ticketPlaySessionKeys: string[];
};
export class RootStore {
    hydrated: boolean;
    ActiveTicketStore: ActiveTicketStore;
    CurrentUserStore: CurrentUserStore;
    MacroStore: MacroStore;
    PluginStore: PluginStore;
    SecurityStore: SecurityStore;
    TabStore: TabStore;
    TicketFormUtilStore: TicketFormUtilStore;
    UtilStore: UtilStore;
    GrispiNewsStore: GrispiNewsStore;

    constructor(session?: RootStoreHydrationData['session']) {
        this.ActiveTicketStore = new ActiveTicketStore();
        this.CurrentUserStore = new CurrentUserStore();
        this.MacroStore = new MacroStore();
        this.PluginStore = new PluginStore();
        this.SecurityStore = new SecurityStore(session);
        this.TabStore = new TabStore();
        this.TicketFormUtilStore = new TicketFormUtilStore();
        this.UtilStore = new UtilStore();
        this.GrispiNewsStore = new GrispiNewsStore();
        this.hydrated = false;
        makeAutoObservable(this);
    }

    resetStores = (): void => {
        runInAction(() => {
            this.ActiveTicketStore = new ActiveTicketStore();
            this.CurrentUserStore = new CurrentUserStore();
            this.MacroStore = new MacroStore();
            this.PluginStore = new PluginStore();
            this.SecurityStore = new SecurityStore({} as Session);
            this.TabStore = new TabStore();
            this.TicketFormUtilStore = new TicketFormUtilStore();
            this.UtilStore = new UtilStore();
            this.GrispiNewsStore = new GrispiNewsStore();
            this.hydrated = false;
        });
    };

    hydrate = ({ session, openTabKeys, ticketPlaySessionKeys }: RootStoreHydrationData): void => {
        this.SecurityStore.updateStore(session);
        this.TabStore.hydrate(openTabKeys, ticketPlaySessionKeys);
        this.CurrentUserStore.hydrate(session);
        this.hydrated = true;
    };
}
